export const FORM_ID = 'containers/ForgottenPasswordRequestForm';
